import { CartItemViewModel } from '../../../Purchase/Cart/Item/ViewModels/CartItemViewModel.csharp';
import { GoogleTagManagerDataLayer } from '../GoogleTagManagerDataLayer';
import { IGoogleTagManagerNonAnalyticsTracker } from '../IGoogleTagManagerNonAnalyticsTracker';
import { NonAnalyticsEvent } from './NonAnalyticsEvent';
import { NonAnalyticsEvents } from './NonAnalyticsEvents';
import { PriceSpiderPurchaseData } from './PriceSpiderPurchaseData';

export class NonAnalyticsTracker implements IGoogleTagManagerNonAnalyticsTracker {
    private readonly _googleTagManagerDataLayer = new GoogleTagManagerDataLayer();
    private readonly _currency = 'NOK';

    trackPriceSpiderPurchase(products: CartItemViewModel[]): void {
        const model: NonAnalyticsEvent<PriceSpiderPurchaseData> = {
            event: NonAnalyticsEvents.priceSpiderPurchase,
            data: {
                products: products.map((p) => ({
                    gtin: p.gtin,
                    sku: p.code,
                    currency: this._currency,
                    price: p.priceSpiderPrice,
                    quantity: p.quantityOrdered,
                    brand: p.nameInfo.mainName,
                    name: p.nameInfo.fullName
                }))
            }
        };
        this._googleTagManagerDataLayer.push(model);
    }
}
